/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".ui-table[_ngcontent-%COMP%]   .ui-sortable-column[_ngcontent-%COMP%], .ui-table-tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]{width:230px;text-align:center}@media screen{#print-content[_ngcontent-%COMP%], .print-content[_ngcontent-%COMP%]{display:none!important;visibility:hidden!important}}html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}[_nghost-%COMP%]     .ui-message.ui-message-success{border:\"1px solid black\";margin:\"0.5%\"}"];
export { styles as styles };

